import { registerApplication, start, addErrorHandler } from 'single-spa';
import { constructApplications, constructRoutes, constructLayoutEngine } from 'single-spa-layout';
import * as Sentry from '@sentry/browser';

import './styles.scss';

let maintenanceManager: any;

const layoutData = {
  props: {},
  loaders: {
    withSidebar: `<div class="loader-with-sidebar">
                    <svg class="root-loader-circular">
                      <circle class="path" cx="50" cy="50" r="16" fill="none" stroke="#8B8C9E" stroke-width="3" stroke-miterlimit="10" />
                    </svg>
                  </div>
                  `,
    default: `<span></span>`,
  },
};

const routes = constructRoutes(document.querySelector('#single-spa-layout'), layoutData);
const applications = constructApplications({
  routes,
  async loadApp({ name }) {
    try {
      return await System.import(name);
    } catch (error) {
      console.error(`Failed to load application ${name}:`, error);

      // if (!maintenanceManager) {
      //   const { maintenanceManager: mm } = await import('./maintenance/maintenance-manager');
      //   maintenanceManager = mm;
      // }

      // if (maintenanceManager.isCriticalModule(name)) {
      //   // TODO: uncomment if needed to show something on critical module load failure
      //   // maintenanceManager.showMaintenancePage('module', `Failed to load ${name}: ${error.message}`);
      //   throw error;
      // }

      throw error;
    }
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

addErrorHandler(async (error) => {
  console.error('Single-spa error:', error);

  // const errorMessage = error.message || error.toString();
  // const failedModule = [
  //   '@dar-dms/utils',
  //   '@dar-dms/topbar',
  //   '@dar-dms/chat',
  //   '@dar-dms/bot',
  //   '@dar-dms/moms',
  // ].find((module) => errorMessage.includes(module));

  // if (failedModule) {
  //   if (!maintenanceManager) {
  //     const { maintenanceManager: mm } = await import('./maintenance/maintenance-manager');
  //     maintenanceManager = mm;
  //   }
  //   maintenanceManager.showMaintenancePage('module', `Critical module error: ${failedModule}`);
  // }

  if (typeof Sentry !== 'undefined' && Sentry.captureException) {
    Sentry.captureException(error);
  }
});

applications.forEach(registerApplication);

if (
  process.env.ENVIRONMENT_VALUE === 'stage-dms' ||
  process.env.ENVIRONMENT_VALUE === 'prod' ||
  process.env.ENVIRONMENT_VALUE === 'prod-eu' ||
  process.env.ENVIRONMENT_VALUE === 'prod-us' ||
  process.env.ENVIRONMENT_VALUE === 'prod-5qit-ps'
) {
  Sentry.init({
    dsn: 'https://31ebdb39f4b64c65bf5f54d16389c740@sentry.dar.tech/8',
    integrations: [
      new Sentry.BrowserTracing(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.ENVIRONMENT_VALUE,
  });
}

async function initializeApp() {
  try {
    start();

    if (!maintenanceManager) {
      const { maintenanceManager: mm } = await import('./maintenance/maintenance-manager');
      maintenanceManager = mm;
    }

    maintenanceManager.startHealthMonitoring(120000, process.env.ENVIRONMENT_VALUE);

    if (
      process.env.NODE_ENV === 'development' ||
      !process.env.ENVIRONMENT_VALUE ||
      process.env.ENVIRONMENT_VALUE === 'dev'
    ) {
      const { createMaintenanceUtils } = await import('./maintenance/maintenance-utils');
      (window as any).maintenanceUtils = createMaintenanceUtils(maintenanceManager, process.env.ENVIRONMENT_VALUE);
    }
  } catch (error) {
    console.error('Failed to initialize DMS Root Config:', error);

    // if (maintenanceManager) {
    //   maintenanceManager.showMaintenancePage('module', 'Application initialization failed');
    // } else {
    //   window.location.href =
    //     '/maintenance.html?error=module&details=' + encodeURIComponent('Application initialization failed');
    // }
  }
}

initializeApp();
